/**
 * Extrai mensagem legível de erros Axios / respostas Laravel (422, 500, etc.).
 * Suporta: message, error string, error.message, errors (validação).
 */
export function getApiErrorMessage(err, fallback = "") {
  const fb = fallback || "Não foi possível concluir a operação.";
  const res = err && err.response;
  if (!res || res.data === undefined || res.data === null) {
    if (err && typeof err.message === "string" && err.message) {
      return err.message;
    }
    return fb;
  }

  const data = res.data;

  if (typeof data === "string" && data.trim()) {
    return data.trim();
  }

  if (typeof data.message === "string" && data.message.trim()) {
    return data.message.trim();
  }

  if (data.error !== undefined && data.error !== null) {
    if (typeof data.error === "string" && data.error.trim()) {
      return data.error.trim();
    }
    if (
      typeof data.error === "object" &&
      typeof data.error.message === "string" &&
      data.error.message.trim()
    ) {
      return data.error.message.trim();
    }
  }

  if (data.errors && typeof data.errors === "object") {
    const first = Object.values(data.errors)[0];
    if (Array.isArray(first) && first[0]) {
      return String(first[0]);
    }
    if (typeof first === "string" && first.trim()) {
      return first.trim();
    }
  }

  return fb;
}
